export default __webpack_public_path__ + "static/media/claim-your-places.a4baa6ff.svg";